import { useLanguage } from "../context/LanguageContext";
import { Mail, Phone, MapPin, Linkedin } from "lucide-react";

const HeroSection = ({ data }) => {
  const { language, t } = useLanguage();

  const getLocalizedText = (field) => {
    if (typeof field === 'string') return field;
    return language === 'no' ? field.no : field.en;
  };

  return (
    <section data-testid="hero-section" className="py-24 md:py-32">
      <div className="animate-fade-in-up">
        {/* Name and Title */}
        <div className="mb-8">
          <p className="text-sm text-sky-600 uppercase tracking-widest font-semibold mb-3">
            {t('Strategisk Finansleder', 'Strategic Finance Executive')}
          </p>
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight leading-tight text-slate-900 mb-2">
            {data.name}
          </h1>
          <p className="text-2xl md:text-3xl text-slate-500 font-medium">{data.title}</p>
        </div>

        {/* Summary */}
        <p className="text-lg md:text-xl leading-relaxed text-slate-600 max-w-3xl mb-10 animation-delay-100 animate-fade-in-up">
          {getLocalizedText(data.summary)}
        </p>

        {/* Contact Info */}
        <div className="flex flex-wrap gap-6 text-slate-600 animation-delay-200 animate-fade-in-up">
          <a 
            href={`mailto:${data.contact.email}`}
            data-testid="contact-email"
            className="flex items-center gap-2 hover:text-sky-600 transition-colors duration-300"
          >
            <Mail className="w-4 h-4" />
            <span className="text-sm md:text-base">{data.contact.email}</span>
          </a>
          
          <a 
            href={`tel:${data.contact.phone}`}
            data-testid="contact-phone"
            className="flex items-center gap-2 hover:text-sky-600 transition-colors duration-300"
          >
            <Phone className="w-4 h-4" />
            <span className="text-sm md:text-base">{data.contact.phone}</span>
          </a>
          
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4" />
            <span className="text-sm md:text-base">
              {data.contact.address}, {getLocalizedText(data.contact.country)}
            </span>
          </div>

          <a 
            href={data.contact.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-linkedin"
            className="flex items-center gap-2 hover:text-sky-600 transition-colors duration-300"
          >
            <Linkedin className="w-4 h-4" />
            <span className="text-sm md:text-base">LinkedIn</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
